'use client'

import { getCookie } from '@patrianna/shared-utils/cookie'
import cx from 'classnames'

import HorizontalScroll from 'containers/HorizontalScroll'
import slotsClasses from 'pageContainers/Home/components/SlotsRow/styles.module.scss'
import { useAppSelector } from 'src/store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import EXTERNAL_LINKS from 'temp/externalLinks.json'

import Offers from '../banners/Offers'
import SocialBanner from '../banners/SocialBanner'
import classes from '../styles.module.scss'

type Props = {
  cookies: string
}

export function CategoryGuestBannersClient({ cookies }: Props) {
  const loggedIn = useAppSelector(isLoggedInSelector)
  const loggedInFromCookie = Boolean(getCookie('LOGGED_IN', cookies))
  const visitedFb = getCookie('IS_USER_VISITED_FB', cookies)
  const visitedInst = getCookie('IS_USER_VISITED_INSTAGRAM', cookies)
  const visitedX = getCookie('IS_USER_VISITED_X', cookies)

  if (loggedIn || loggedInFromCookie) {
    return null
  }

  return (
    <HorizontalScroll
      autoScrollTimeInterval={5000}
      scrolledItemDataAttr='data-banner'
      classNameContainer={cx(slotsClasses.root, classes.bannerContainerRoot)}
      gap={8}
    >
      <Offers loggedIn={false} scEnabled={false} />
      {!visitedFb && <SocialBanner imgKey='facebook' link={EXTERNAL_LINKS.visitFB} cookie='IS_USER_VISITED_FB' />}
      {!visitedInst && (
        <SocialBanner imgKey='instagram' link={EXTERNAL_LINKS.instagram} cookie='IS_USER_VISITED_INSTAGRAM' />
      )}
      {!visitedX && <SocialBanner imgKey='x' link={EXTERNAL_LINKS.x} cookie='IS_USER_VISITED_X' />}
    </HorizontalScroll>
  )
}
